module.exports = __webpack_public_path__ + "img/whatsapp.ca6e9b9b.svg";